import { render, staticRenderFns } from "./DetailStatusesStatisticDomainAdv.vue?vue&type=template&id=7b1ff05e"
import script from "./DetailStatusesStatisticDomainAdv.vue?vue&type=script&lang=js"
export * from "./DetailStatusesStatisticDomainAdv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports